import { PureComponent, PropsWithChildren } from "react";

export default class DescriptionPaneEditorLabel extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-description-pane__editor-label">
        {this.props.children}
      </div>
    );
  }
}
